import { OVERFLOW_CONSTANTS } from 'fk-cp-common-components/utils/OtpConstants';

const freezeBodyScroll = () => {
	document.documentElement.style.overflow = OVERFLOW_CONSTANTS.HIDDEN;
	document.body.scroll = OVERFLOW_CONSTANTS.NO_OVERFLOW;
};

const allowBodyScroll = () => {
	document.documentElement.style.overflow = OVERFLOW_CONSTANTS.SCROLL;
	document.body.scroll = OVERFLOW_CONSTANTS.OVERFLOW;
};

const clearTheSpace = val => {
	return val.replace(/ /g, '');
};

const convertStringToRegex = strPattern => {
	if (strPattern !== '') {
		const tmpPattern = strPattern.indexOf('/') === 0 ? strPattern.substring(1) : strPattern;
		const patternEnd = tmpPattern.lastIndexOf('/');
		if (patternEnd > 0) {
			const pattern = tmpPattern.substring(0, patternEnd);
			const flags = tmpPattern.substring(patternEnd + 1);
			return new RegExp(pattern, flags);
		}
	}
	return null;
};

export { freezeBodyScroll, allowBodyScroll, clearTheSpace, convertStringToRegex };
